import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import { getEntityWebsiteReportEbook } from '../../utils';

const PublishSuccessfulDialog = ({ open, handleClose }) => {
	const entity = getEntityWebsiteReportEbook();

	return (
		<GenericDialog
			content={
				<Typography variant="body1">
					{_e('congratulations_published', { entity })}
				</Typography>
			}
			confirmAction={handleClose}
			handleClose={handleClose}
			open={open}
			title={_e('published')}
		/>
	);
};

PublishSuccessfulDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
};

export default PublishSuccessfulDialog;
